// extracted by mini-css-extract-plugin
export default {"details":"styles_details__88fRL","field":"styles_field__wTqfT","form":"styles_form__lZhaC"};